import { createBrowserRouter, RouterProvider, useRouteError } from "react-router";
import ScrollToTop from "../components/ScrollToTop";
import Content from "../components/Layout/Content";
import useAuthentication from "../auth/useAuthentication";
import IdleTimer from "../auth/IdleTimer";
import UtloggetSide from "../auth/UtloggetSide";
import { lazy } from "react";
import Landingsside from "../skjema/landingsside/Landingsside";

const InnloggetRouterProvider = lazy(() => import("./InnloggetRouterProvider"));
const BegrensetRouterProvider = lazy(() => import("./BegrensetRouterProvider"));

export const BubbleError = () => {
  //Kaster feil viderer for å ta den imot i ErrorBoundary
  throw useRouteError();
};

const utloggetRouter = createBrowserRouter([
  {
    path: "/",
    element: (
      <>
        <ScrollToTop />
        <Content />
      </>
    ),
    errorElement: <BubbleError />,
    children: [
      {
        path: "/",
        element: <Landingsside />,
      },
      {
        path: "*",
        element: <Landingsside />,
      },
      {
        path: "/utlogget",
        element: <UtloggetSide />,
      },
    ],
  },
]);

const AnmeldelseRouter = () => {
  const { userInfo } = useAuthentication();
  if (!userInfo) {
    return <RouterProvider router={utloggetRouter} />;
  } else if (!userInfo.harTilgang) {
    return (
      <IdleTimer>
        <BegrensetRouterProvider />
      </IdleTimer>
    );
  } else {
    return (
      <IdleTimer>
        <InnloggetRouterProvider />
      </IdleTimer>
    );
  }
};

export default AnmeldelseRouter;
